import { useLocation, Link, useNavigate } from 'react-router-dom'
import {
  AlertTriangle,
  BarChart3,
  Users,
  Flag,
  LogOut,
} from 'lucide-react'
import { clsx } from 'clsx'

interface NavItem {
  label: string
  href: string
  icon: React.ReactNode
}

const navigation: NavItem[] = [
  {
    label: 'Moderation',
    href: '/moderation',
    icon: <AlertTriangle className="h-5 w-5" />,
  },
  {
    label: 'Analytics',
    href: '/analytics',
    icon: <BarChart3 className="h-5 w-5" />,
  },
  {
    label: 'Users',
    href: '/users',
    icon: <Users className="h-5 w-5" />,
  },
  {
    label: 'Reports',
    href: '/reports',
    icon: <Flag className="h-5 w-5" />,
  },
]

export function Sidebar() {
  const location = useLocation()
  const navigate = useNavigate()

  function handleSignOut() {
    sessionStorage.removeItem('okaiwa_admin_token')
    navigate('/login')
  }

  return (
    <aside className="flex w-64 flex-col bg-sidebar-bg">
      {/* Logo */}
      <div className="flex h-16 items-center px-6">
        <span className="text-xl font-bold text-white">Okaiwa</span>
        <span className="ml-2 rounded bg-brand-600 px-1.5 py-0.5 text-xs font-semibold text-white">
          Admin
        </span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 px-3 py-4">
        {navigation.map((item) => {
          const isActive =
            location.pathname === item.href ||
            location.pathname.startsWith(`${item.href}/`)

          return (
            <Link
              key={item.href}
              to={item.href}
              className={clsx(
                'flex items-center space-x-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-sidebar-active text-sidebar-text-active'
                  : 'text-sidebar-text hover:bg-sidebar-hover hover:text-sidebar-text-active',
              )}
            >
              {item.icon}
              <span>{item.label}</span>
            </Link>
          )
        })}
      </nav>

      {/* Footer */}
      <div className="border-t border-gray-700 px-3 py-4">
        <div className="flex items-center space-x-3 rounded-lg px-3 py-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-600 text-xs font-bold text-white">
            A
          </div>
          <div className="flex-1 truncate">
            <p className="truncate text-sm font-medium text-sidebar-text-active">
              Admin User
            </p>
            <p className="truncate text-xs text-sidebar-text">
              admin@globodai.com
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={handleSignOut}
          className="mt-2 flex w-full items-center space-x-2 rounded-lg px-3 py-2 text-sm text-sidebar-text transition-colors hover:bg-sidebar-hover hover:text-sidebar-text-active"
        >
          <LogOut className="h-4 w-4" />
          <span>Sign out</span>
        </button>
      </div>
    </aside>
  )
}
